import styled, { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { IconDrag } from '@hivebrite/design-system/Icon';

import TooltipPanel from 'hb-builder/components/common/TooltipPanel';

const DraggableAccordionTitle = ({ handleDrag, label, isDraggable }) => {
  const { colors } = useTheme();

  return (
    <TitleWrapper>
      <TooltipPanel
        withTooltip={!isDraggable}
        text={__('Close all the drawers to reorder them')}
      >
        <DraggableArea
          onPointerDown={isDraggable ? handleDrag : null}
          $isDragable={isDraggable}
        >
          <DragIcon color={isDraggable ? 'inherit' : colors.horizon}>
            <IconDrag size={20} />
          </DragIcon>
        </DraggableArea>
      </TooltipPanel>
      {label}
    </TitleWrapper>
  );
};

export default DraggableAccordionTitle;

const TitleWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  fontWeight: 'inherit',
  fontSize: 'inherit',
  color: 'inherit',
  py: 0,
}))``;

const DraggableArea = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -10px;
  cursor: ${(props) => (props.$isDragable ? 'all-scroll' : 'pointer')};
`;

const DragIcon = styled(Box).attrs(({ color }) => ({
  color,
}))``;
